import React, {
  Fragment,
  useState,
  useEffect,
  useRef,
  useMemo,
  useCallback,
} from "react";
import {
  getMlmfoutletMaster,
  getresbasedmenumaster,
  getDailyplanListMaster,
  saveDailyplanMenuREQ,
  deleteDailyplanerREQ,
  multideleteDailyplanerREQ,
} from "../../../../apiservicescall/api";

import {
  Table,
  Badge,
  Row,
  Card,
  Col,
  Button,
  Container,
  ListGroup,
  Tab,
} from "react-bootstrap";
import { Link } from "react-router-dom";

import Select from "react-select";

import {
  Pagination,
  PaginationItem,
  PaginationLink,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import swal from "sweetalert";
import { Form, FormGroup, Label, Input } from "reactstrap";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Edit } from "@material-ui/icons";
import RctCollapsibleCard from "../RctCollapsibleCard/RctCollapsibleCard";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import MUIDataTable from "mui-datatables";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/Step";
import StepButton from "@material-ui/core/StepButton";
import { de } from "date-fns/locale";

const DailyPlanner = () => {
  const [outletlist, setoutletlist] = useState([]);
  const [selectedrestarant, setSelectedrestarant] = useState([
    { label: "", value: "" },
  ]);
  const [specialmenulist, setSpecialMenu] = useState([]);
  const [selectedspecialMenu, setSelectedSpecialMenu] = useState([
    { label: "", value: "" },
  ]);

  const [isView, setIsview] = useState(false);
  const [isedit, setIsedit] = useState(false);
  const [errors, setErrors] = useState({
    menuId: null,
    planDate: null,
  });
  const [formIsValid, setFormIsValid] = useState(false);

  const [startDate, setDate] = useState(new Date());
  const [endDate, setendDate] = useState(new Date());
  const today = new Date();

  const [comonPopupModal, setcomonPopupModal] = useState(false);
  const [deletepopup, setDeletepopup] = useState(false);
  const [multiDeleteModal, setMultiDeleteModal] = useState(false);

  const [editmenuavailablity, setEditmenuavailablity] = useState(false);

  const [DailyMenuPlan, setDailyMenuPlan] = useState([]);

  const [DailyPlanDetail, setDailyPlanDetail] = useState([
    {
      menuId: "",
      outletCode: 0,
      planDate: "",
    },
  ]);
  const [multiDelData, setMultiDelData] = useState([
    {
      outletCode: 0,
      fromDate: "",
      toDate: "",
    },
  ]);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
 
 



  useEffect(() => {
    getRestarantmaster();
  }, []);

  const getRestarantmaster = async () => {
    let getsoutletList = await getMlmfoutletMaster();

    let getsoutletValue = (getsoutletList && getsoutletList.data.data) || [];

    let restarantmaster = getsoutletValue.map(({ id, name }) => ({
      label: name,
      value: id,
    }));

    setoutletlist(restarantmaster);
  };

  const getRestarantmenulist = async (e) => {
    let restaurantId = e;
    let getresmenuid = await getresbasedmenumaster(restaurantId);
    console.log("getresmenuid", getresmenuid);

    let getresmenu = getresmenuid.data.data || [];

    console.log("getresmenu getresmenu", getresmenu);

    let specialmenulist = getresmenu.map(({ id, name }) => ({
      label: name,
      value: id,
    }));
    setSpecialMenu(specialmenulist);
  };

  const getDailyPlanerMenuList = async () => {
    let restaurantId = selectedrestarant.value;
    let getDplanList = await getDailyplanListMaster(restaurantId);
   // console.log("getDplanList", getDplanList);
    let getListValue = getDplanList?.data?.data || [];
   // console.log("getListValue", getListValue);
    setDailyMenuPlan(getListValue);
    let totpage = Math.ceil(getListValue.length / itemsPerPage);
    console.log("totpage",totpage);
    setTotalPages(totpage);
    console.log("totalPages",totalPages);
    let titem= getListValue.length;
    setTotalItems(titem); 
    console.log("totalItems",totalItems);
    
  };

  
  const handleChangePage = (event, newPage) => {
    setCurrentPage(newPage);
  };
  
 const onChangeRowsPerPage = (numOfRows) => {
    // let { currentPage, itemsPerPage } = this.state;
    setItemsPerPage(numOfRows);
    
  };

  const deletemenuitemsubscription = async () => {
    // console.log("setMenulistitem", menulistitem);
    let data = DailyPlanDetail;
    let reqformenusubmenu = await deleteDailyplanerREQ(data);

    // console.log("setMenulistitem", reqformenusubmenu);
    // return false;
    if (reqformenusubmenu.data.status === true) {
      setDailyPlanDetail([
        {
          menuId: "",
          planDate: "",
        },
      ]);
      setDeletepopup(false);
      setIsview(false);
      setIsedit(false);
      getDailyPlanerMenuList();
      setMultiDeleteModal(false);
      swal("Deleted!", "success");
    } else {
      // getoutletMenulist(
      //   selectedrestarant.value,
      //   selectedusers.value
      // );
      setMultiDeleteModal(false);
      swal("Oops", "error");
    }
  };

  const multiDeleteDailyMenu = async () => {
    let data;
    let setDate1 =
      startDate.getFullYear() +
      "-" +
      (startDate.getMonth() + 1) +
      "-" +
      startDate.getDate();
    let setDate2 =
      endDate.getFullYear() +
      "-" +
      (endDate.getMonth() + 1) +
      "-" +
      endDate.getDate();

    data = {
      outletCode: selectedrestarant.value,
      fromDate: setDate1,
      toDate: setDate2,
    };
    console.log("multiDelData", data);
    let reqformenusubmenu = await multideleteDailyplanerREQ(data);

    // console.log("setMenulistitem", reqformenusubmenu);
    // return false;
    if (reqformenusubmenu.data.status === true) {
      setMultiDeleteModal(false);
      setIsview(false);
      setIsedit(false);
      getDailyPlanerMenuList();
      setSelectedSpecialMenu([]);
      setDailyPlanDetail([
        {
          menuId: "",
          planDate: "",
        },
      ]);
      setDate(new Date());
      setendDate(new Date());
      swal("Deleted!", "success");
    } else {
      setDeletepopup(false);
      swal("Oops"`${reqformenusubmenu.data.message}`, "error");
    }
  };

  const opnAddNewUserModal = (e) => {
    e.preventDefault();
    setcomonPopupModal(!comonPopupModal);
    setIsview(false);
    setIsedit(false);
    setFormIsValid(false);
  };

  const deletetoggle = (data) => {
    let selectedCustomer = DailyMenuPlan.find(
      (value, index) => index === data?.rowIndex
    );

    console.log("selectedCustomer", selectedCustomer);

    setDailyPlanDetail({
      menuId: selectedCustomer.menuId,
      outletCode: Number(selectedCustomer.outletCode),
      planDate: selectedCustomer.planDate,
    });
    console.log("setDailyPlanDetail", DailyPlanDetail);
    setDeletepopup(true);
    setIsview(true);
    setIsedit(false);
    setFormIsValid(false);
  };

  const Multideletetoggle = () => {
    setMultiDeleteModal(!multiDeleteModal);
    setIsview(false);
    setIsedit(false);
    setFormIsValid(false);
  };

  const saveDailymenulist = async () => {
    let data = "";
    let setDate1 =
      startDate.getFullYear() +
      "-" +
      (startDate.getMonth() + 1) +
      "-" +
      startDate.getDate();

    let multinames =
      selectedspecialMenu &&
      selectedspecialMenu.map((item) => {
        // console.log("item",item);
        return item["value"].toString();
      });
    let multiText = multinames.toString();

    //console.log("Text",Text);

    data = {
      outletCode: selectedrestarant.value,
      menuId: multiText,
      planDate: setDate1,
    };
    console.log("data", data);
    let reqforupload;
    reqforupload = await saveDailyplanMenuREQ(data);

    if (reqforupload?.status === 200) {
      setIsview(false);
      setIsedit(false);
      setSelectedSpecialMenu([null]);
      setDailyPlanDetail([
        {
          menuId: null,
          planDate: null,
        },
      ]);
      getDailyPlanerMenuList();
      setDate(new Date());
      setendDate(new Date());
      setcomonPopupModal(false);
      if (!isedit) {
        swal("Success!", "Daily Planner Added", "success");
      } else {
        swal("Success!", "Daily Planner Updated", "success");
      }
    } else {
      swal("Oops", "Error, Please Try Later", "error");
      setIsview(false);
      setIsedit(false);
      setcomonPopupModal(!comonPopupModal);
      setSelectedSpecialMenu([]);
    }
  };

  const onChangeCommonpopupsetOutletvalue = (key, value) => {
    let addFieldValue = {};
    let errorsLocal = errors;
    let formIsValidLocal = formIsValid;

    if (key == "menuId") {
      if (!value) {
        addFieldValue = { [value]: null };
        errorsLocal["menuId"] = " Please select Menu";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else {
        addFieldValue = { ["menuId"]: value.value };
        errorsLocal["menuId"] = "";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }
    }

    if (key == "planDate") {
      if (!value) {
        addFieldValue = { [key]: null };
        errorsLocal["planDate"] = " Please Select Date";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else {
        addFieldValue = { [key]: value };
        errorsLocal["planDate"] = "";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }
    }
    const newFormData = [{ ...DailyPlanDetail }];
    newFormData[key] = value;
    setDailyPlanDetail(newFormData);
  };

  const CustomClearText = () => "clear all";

  const ClearIndicator = (props) => {
    const {
      children = <CustomClearText />,
      getStyles,
      innerProps: { ref, ...restInnerProps },
    } = props;
    return (
      <div
        {...restInnerProps}
        ref={ref}
        style={getStyles("clearIndicator", props)}
      >
        <div style={{ padding: "0px 5px" }}>{children}</div>
      </div>
    );
  };

  const ClearIndicatorStyles = (base, state) => ({
    ...base,
    cursor: "pointer",
    color: state.isFocused ? "blue" : "black",
  });

  const themeTable = createMuiTheme({
    overrides: {
      MUIDataTable: {
        root: {
          backgroundColor: "#4cb32b",
          height: "10px",
        },
        paper: {
          boxShadow: "none",
        },
      },
      MuiTableRow: {
        root: {
          "&:nth-of-type(odd)": {
            backgroundColor: "white !important",
          },
          "&:nth-of-type(even)": {
            backgroundColor: "#e4e8ef !important",
          },
        },
      },

      MUIDataTableHeadCell: {
        root: {
          backgroundColor: "#008000 !important",
        },
        data: {
          fontWeight: "bold",
          color: "white",
          fontSize: "14px",
        },
      },
    },
  });

  let actionOption = {
    name: "actions",
    label: "Actions",
    options: {
      filter: false,
      sort: false,
      customBodyRender: (summary, tableMeta, updateValue) => {
        // console.log("rowData[11] ", tableMeta.rowData[11])
        return (
          <div className="list-action">
            <span style={{ color: "black" }} className="icon-top-left">
              {/* <button
                type="button"
                className="rct-link-btn edit-btn"
                onClick={() => onEditUser(tableMeta)}
              >
                <i style={{ fontSize: "15px" }} className="ti-pencil"></i>
              </button> */}

              <Link
                className="btn btn-primary shadow btn-xs sharp me-2"
                onClick={() => {
                  deletetoggle(tableMeta);
                }}
                style={{ background: "#008000" }}
              >
                <i className="bi bi-trash"></i>
              </Link>

              {/* <Link
                className="btn btn-primary shadow btn-xs sharp me-2"
                onClick={() => {
                  // setOutletDetails({})
                  viewUser(tableMeta);
                }}
                style={{ background: "#008000" }}
              >
                <i className="fa fa-eye"></i>
              </Link> */}
            </span>
          </div>
        );
      },
    },
  };

  const columns = [
    {
      name: "outletName",
      label: "Outlet Name",
      options: {
        filter: false,
        sort: true,
        customFilterListOptions: { render: (v) => `UID: ${v}` },
        viewColumns: false,
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",
      },
    },

    // {
    //   name: "outletCode",
    //   label: "Outlet Code",
    //   options: {
    //     filter: false,
    //     sort: true,
    //     viewColumns:false,
    //      customFilterListOptions: { render: v => `UID: ${v}` },
    //     fixedHeader: true,
    //     responsive: "stacked",
    //     filterType: "textField",
    //   },
    // },
    {
      name: "menuName",
      label: "Menu Name",
      options: {
        filter: false,
        sort: true,
        customFilterListOptions: { render: (v) => `UID: ${v}` },
        viewColumns: false,
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",
      },
    },

    {
      name: "menuId",
      label: "Menu ID",
      options: {
        filter: false,
        sort: true,
        viewColumns: false,
        customFilterListOptions: { render: (v) => `UID: ${v}` },
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",
      },
    },

    {
      name: "planDate",
      label: "Plan Date",
      options: {
        filter: false,
        sort: true,
        viewColumns: false,
        customFilterListOptions: { render: (v) => `UID: ${v}` },
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",
      },
    },

    actionOption,
  ];

  const options = {
    filter: false,
    setFilterChipProps: (colIndex, colName, data) => {
      return {
        color: "primary",
        variant: "outlined",
        className: "testClass123",
      };
    },
    // viewColumns:false,
    filterType: "dropdown",
    selectableRows: false,
    responsive: "stacked",
    // count: totalItems,
    // page: currentPage,
    // pagination: true,
    // rowsPerPage: itemsPerPage,
    // rowsPerPageOptions: [10, 15, 100],
    // search: false,
    // textLabels: {
    // 	body: {
    // 		noMatch: labelmessage
    // 	},
    // },

    fixedHeader: true,
    tableBodyHeight: "425px",

    fixedSelectColumn: true,
    search: false,
     page: currentPage,

    pagination: true,
    serverSide: false,
     rowsPerPage: itemsPerPage,
    rowsPerPageOptions: [10,15,50],
    // onColumnSortChange: this.customSort,
    onChangePage:(newPage)=>{handleChangePage(newPage)},
    onChangeRowsPerPage:(numOfRows)=>{onChangeRowsPerPage(numOfRows)},
    //onChangePage: (page) => this.changePage(page),
    download: false,
    print: false,
    onFilterChange: (
      column,
      filterList,
      type,
      filterVal,
      filterOptions,
      changedColumnIndex,
      displayData
    ) => {
      if (type === "chip") {
        var newFilters = () => filterList;
        this.handleFilterSubmit(newFilters);
      }
    },

    onSearchChange: (searchValue) => this.customSearch(searchValue),
    // table's internal filterList
    confirmFilters: true,

    // Calling the applyNewFilters parameter applies the selected filters to the table
    customFilterDialogFooter: (currentFilterList, applyNewFilters) => {
      return (
        <div style={{ marginTop: "40px" }}>
          <Button
            variant="contained"
            onClick={() => this.handleFilterSubmit(applyNewFilters)}
          >
            Apply Filters
          </Button>
        </div>
      );
    },
    // callback that gets executed when filters are confirmed
    onFilterConfirm: (filterList) => {
      //// console.log('onFilterConfirm');
      // console.log('filterList', filterList);
    },

    onFilterDialogOpen: () => {
      //// console.log('filter dialog opened');
    },
    onFilterDialogClose: () => {
      //// console.log('filter dialog closed');
    },
    // customToolbar: () => {
    //   return (
    //     <>
    //       {
    //         <>
    //             <a
    //               href="#"
    //               style={{
    //                 backgroundColor: "#008000",
    //                 color: "white",
    //                 fontSize: "medium",
    //               }}
    //               onClick={(e) => {
    //                 setMultiDeleteModal(true);
    //                 // opnAddNewUserModal(e);
    //                 // setCustomerDetail({});
    //               }}
    //               className="caret btn-sm mr-10"
    //             >
    //               Delete  <i className="zmdi zmdi-lus"></i>
    //             </a>

    //         </>
    // }
    //     </>
    //   );
    // },
  };

  return (
    <>
      <div className="row">
        <div className="col-md-12 col-lg-12 col-sm-12 col-xl-12">
          <Card>
            <div class="row">
              <div class="col-3 col-md-3 col-lg-3">
                <div class="form-group">
                  <h3 className="me-auto main-hd">Daily Planner</h3>
                </div>
              </div>
              <div class="col-6 col-md-6 col-lg-6 row">
                <Card.Header
                  className="card-title main-card"
                  style={{ marginLeft: "220px", justifyContent: "end" }}
                >
                  <div class="col-4 col-md-4 col-lg-4 form-group main-frm-grp">
                    <label as="a" variant="badge badge-rounded badge-danger">
                      Restaurant
                    </label>
                    <Select
                      options={outletlist}
                      value={selectedrestarant}
                      closeMenuOnSelect={false}
                      // search
                      // name="stateCode"
                      placeholder="Choose"
                      // autoComplete="off"
                      onChange={(e) => {
                        setSelectedrestarant(e);
                        console.log("e", e);
                        getRestarantmenulist(e.value);
                      }}
                    />
                  </div>

                  <div
                    class=" col-2 col-md-2 col-lg-2 mt-4  form-group"
                    style={{ width: "9.333333%" }}
                  >
                    {/* {selectedusers.value && selectedrestarant.value && */}

                    <Button
                      className="mt-2 btn-primary"
                      variant="success dark btn-sm "
                      // disabled={restarantvalue.value == ""}
                      style={{
                        backgroundColor: "green",
                        borderRadius: "2px",
                        border: "0px solid",
                      }}
                      onClick={() => {
                        // getRestarantmenulist();
                        getDailyPlanerMenuList();
                      }}
                    >
                      <i
                        // class="fas fa-plus"
                        onClick={() => {}}
                      >
                        Get{" "}
                      </i>{" "}
                    </Button>

                    {/* } */}
                  </div>
                  <div class=" col-2 col-md-2 col-lg-2 mt-4 form-group">
                    <Button
                      className="mt-2"
                      variant="success dark btn-sm"
                      // disabled={restarantvalue.value == ""}
                      style={{
                        backgroundColor: "#1F3DB6",
                        borderRadius: "2px",
                        border: "0px solid",
                      }}
                      onClick={(e) => {
                        opnAddNewUserModal(e);
                      }}
                    >
                      <i onClick={() => {}}>Add </i>{" "}
                    </Button>

                    {/* } */}
                  </div>
                  <div class=" col-2 col-md-2 col-lg-2 mt-4 form-group">
                    <Button
                      className="mt-2"
                      variant="success dark btn-sm"
                      // disabled={restarantvalue.value == ""}
                      style={{
                        backgroundColor: "#b61f3d",
                        borderRadius: "2px",
                        border: "0px solid",
                      }}
                      onClick={() => {
                        Multideletetoggle();
                      }}
                    >
                      <i onClick={() => {}}>Delete </i>{" "}
                    </Button>

                    {/* } */}
                  </div>
                </Card.Header>
              </div>
            </div>
            <Card.Body>
              <RctCollapsibleCard fullBlock>
                <RctCollapsibleCard fullBlock>
                  <MuiThemeProvider theme={themeTable}>
                    <MUIDataTable
                      data={DailyMenuPlan}
                      columns={columns}
                      options={options}
                      columOrder={columns}
                    />
                  </MuiThemeProvider>
                </RctCollapsibleCard>
              </RctCollapsibleCard>
            </Card.Body>
          </Card>
          <Modal
            isOpen={comonPopupModal || deletepopup || multiDeleteModal}
            // toggle={() => onClose()}
            style={{
              maxWidth:
                (comonPopupModal && "600px") || (multiDeleteModal && "600px"),
            }}
            backdrop="static"
          >
            <ModalHeader>
              {(deletepopup && " Delete ") ||
                (multiDeleteModal && "Date wise Delete") ||
                (comonPopupModal && isedit === false
                  ? `Add  Daily Planner`
                  : `Update Daily Planner ${" "}  ${" "}`)}
            </ModalHeader>
            <ModalBody>
              {deletepopup && (
                <>
                  <span>
                    Are you sure want to delete item ? <strong> </strong>
                  </span>
                </>
              )}

              {multiDeleteModal && (
                <>
                  <div className="row">
                    <div className="col-sm-3 col-md-3 col-xl-3  pop-up-tab">
                      <FormGroup>
                        <Label for="startDate">
                          From Date<span class="text-danger">*</span>
                        </Label>
                        <DatePicker
                          dateFormat="yyyy-MM-dd"
                          // selectsStart
                          selected={startDate}
                          // minDate={today}
                          //startDate={rangeStart}
                          // endDate={rangeEnd}
                          onChange={(e) => {
                            setDate(e);
                            console.log("eeeee", e);
                            onChangeCommonpopupsetOutletvalue("startDate", e);
                          }}
                          //value={menulistitem?.startDate}
                        />

                        <span style={{ color: "red" }}>
                          {errors["startDate"]}
                        </span>
                      </FormGroup>
                    </div>

                    <div className="col-sm-3 col-md-3 col-xl-3  pop-up-tab">
                      <FormGroup>
                        <Label for="endDate">
                          To Date<span class="text-danger">*</span>
                        </Label>

                        <DatePicker
                          dateFormat="yyyy-MM-dd"
                          selectsEnd
                          selected={endDate}
                          minDate={startDate}
                          startDate={startDate}
                          //endDate={rangeEnd}
                          onChange={(e) => {
                            setendDate(e);
                            onChangeCommonpopupsetOutletvalue("endDate", e);
                            console.log("end", e);
                          }}
                        />

                        <span style={{ color: "red" }}>
                          {errors["endDate"]}
                        </span>
                      </FormGroup>
                    </div>
                  </div>
                </>
              )}

              {comonPopupModal && (
                <>
                  <div className="row">
                    {/* <div className="col-sm-6 col-md-6 col-xl-6">
                  <FormGroup>
                    <Label for="customerId">
                      Customer ID<span class="text-danger">*</span>
                    </Label>
                    <Input
                      type="customerId"
                      name="customerId"
                      id="customerId"
                      placeholder="customerId "
                      maxLength="40"
                      required
                      autoComplete="off"
                      onChange={(e) =>
                        onChangeCommonpopupsetOutletvalue("customerId", e.target.value.trimStart())
                      }
                      value={menulistitem?.customerId}
                    />
                    <span style={{ color: "red" }}>{errors["customerId"]}</span>
                  </FormGroup>
                </div> */}
                    <div
                      className="col-sm-6 col-md-6 col-xl-6  pop-up-tab"
                      style={{ width: "40%" }}
                    >
                      <FormGroup>
                        <label
                          as="a"
                          variant="badge badge-rounded badge-danger"
                        >
                          Menu Item <span class="text-danger">*</span>
                        </label>
                        <Select
                          options={specialmenulist}
                          // defaultValue={selectedOutletvalue}
                          isMulti
                          // value={selectedslotmaster || { label: "", value: "" }}
                          // value={selectedspecialMenu}
                          // value={
                          //   selectedspecialMenu &&
                          //   selectedspecialMenu["value"] != ""
                          //     ? selectedspecialMenu
                          //     : ""
                          // }
                          closeMenuOnSelect={false}
                          styles={{
                            clearIndicator: ClearIndicatorStyles,
                          }}
                          components={{ ClearIndicator }}
                          search
                          name="menuId"
                          placeholder="Choose"
                          // isDisabled={editmenuavailablity}
                          onChange={(e) => {
                            // console.log("", selectedslotmaster)
                            // console.log("",   (let  value of selectedslotmaster )  items.value != ""))
                            setSelectedSpecialMenu(e);
                            setSelectedSpecialMenu([...e]);
                            onChangeCommonpopupsetOutletvalue("menuId", e);
                            console.log("eee", e);
                            // const newFormData = {...menuAvailablitMaster};
                            // newFormData["slotId"] = [...e.value];
                            // setMenuAvailablitMaster(newFormData);
                          }}
                          autoComplete="off"
                        />
                      </FormGroup>
                      <span style={{ color: "red" }}>{errors["menuId"]}</span>
                    </div>

                    <div className="col-sm-3 col-md-3 col-xl-3  pop-up-tab">
                      <FormGroup>
                        <Label for="planDate">
                          Plan Date<span class="text-danger">*</span>
                        </Label>
                        <DatePicker
                          dateFormat="yyyy-MM-dd"
                          // selectsStart
                          selected={startDate}
                          minDate={today}
                          //startDate={rangeStart}
                          // endDate={rangeEnd}
                          onChange={(e) => {
                            setDate(e);
                            console.log("eeeee", e);
                            onChangeCommonpopupsetOutletvalue("planDate", e);
                          }}
                        />

                        <span style={{ color: "red" }}>
                          {errors["planDate"]}
                        </span>
                      </FormGroup>
                    </div>
                  </div>
                </>
              )}
            </ModalBody>
            <ModalFooter>
              {deletepopup && (
                <>
                  <Button
                    variant="success"
                    onClick={() => {
                      deletemenuitemsubscription();
                      // deletemenuitemsubscription();
                      //    deleteitem("Deletemenu");
                    }}
                  >
                    Delete
                  </Button>
                  <Button
                    variant="danger"
                    onClick={() => {
                      setDeletepopup(false);
                    }}
                  >
                    Cancel
                  </Button>
                </>
              )}

              {multiDeleteModal && (
                <>
                  <Button
                    variant="success"
                    onClick={() => {
                      multiDeleteDailyMenu();
                    }}
                  >
                    Delete
                  </Button>
                  <Button
                    variant="danger"
                    onClick={() => {
                      setMultiDeleteModal(false);
                    }}
                  >
                    Cancel
                  </Button>
                </>
              )}

              {comonPopupModal && (
                <>
                  {isView === false && isedit === false && (
                    <Button
                      variant="primary"
                      className={!formIsValid ? "btn-disabled" : "btn-primary"}
                      disabled={!formIsValid}
                      onClick={() => {
                        saveDailymenulist();
                      }}
                    >
                      Submit
                    </Button>
                  )}
                  {isView === false && isedit === true && (
                    <Button
                      variant="contained"
                      className={!formIsValid ? "btn-disabled" : "btn-primary"}
                      disabled={!formIsValid}
                      onClick={() => {
                        // saveupdateSubcribemenulist();
                        // console.log("saveupdateSubcribemenulist", );
                      }}
                    >
                      Update
                    </Button>
                  )}

                  <Button
                    variant="secondary"
                    onClick={() => {
                      // setMainMenuModal(false);
                      // setSubMenuModal(false);
                      // setMenuFoodItemModal(false);
                      // setOpenImagePopup(false);
                      setErrors({});
                      setFormIsValid();
                      setcomonPopupModal(false);
                      setIsview(false);
                      setIsedit(false);
                      setSelectedSpecialMenu([{ label: "", value: "" }]);
                      setDate(new Date());
                    }}
                  >
                    Cancel
                  </Button>
                </>
              )}
            </ModalFooter>
          </Modal>
        </div>
      </div>
    </>
  );
};

export default DailyPlanner;
